import { useQuery } from '@tanstack/react-query';
import { runQuery } from '@shadcn/hooks/use-run-query';
import { projectStore } from '~/lib/stores/project';

const getUserCountsByDay = ({ days }: { days: number }) => {
  const sql = `
    WITH days_series AS (
      SELECT generate_series(
        date_trunc('day', now() - interval '${Number(days) - 1} days'),
        date_trunc('day', now()),
        '1 day'::interval
      )::date AS date
    )
    SELECT
      d.date,
      COALESCE(u.users, 0)::int as users
    FROM
      days_series d
    LEFT JOIN (
      SELECT
        date_trunc('day', created_at AT TIME ZONE 'UTC')::date as date,
        count(id) as users
      FROM
        auth.users
      GROUP BY 1
    ) u ON d.date = u.date
    ORDER BY
      d.date ASC;
  `;

  return runQuery({
    query: sql,
  });
};

export const useGetUserCountsByDay = (days: number) => {
  const projectId = projectStore.projectId.get();
  return useQuery({
    queryKey: ['user-counts', projectId, days],
    queryFn: () => getUserCountsByDay({ days }),
    enabled: !!projectId,
    retry: false,
  });
};
